import React from 'react'
import { useAtom } from 'jotai'
import { useApi } from './use-api-requests.hook'
import { affinityLogoAtom } from '@store/store'
import { dataStateAtom } from '@store/atoms'

type AffinityLogoResponse = {
	Descrizione: string
	Immagine: string | null
	TabFin: string | null
}

export const useAffinityLogo = () => {
	const [, setAffinityLogo] = useAtom(affinityLogoAtom)
	const [, setState] = useAtom(dataStateAtom)

	const [data, trigger] = useApi<AffinityLogoResponse>({
		request: 'Utility/GetAzAffinity',
		method: 'GET',
		sleeper: true,
	})

	React.useEffect(() => {
		if (data?.Immagine) {
			setAffinityLogo(data.Immagine)
		}

		const financialTable = data?.TabFin?.trim()

		if (!financialTable) return

		setState((prev) => ({
			...prev,
			token: {
				...prev.token,
				StartingValues: {
					...prev.token.StartingValues,
					FinancialTable: financialTable,
				},
			},
		}))
	}, [data, setAffinityLogo, setState])

	const fetchLogo = (code: string) => {
		if (!code) return
		trigger({ query: { CAF: code.trim() } })
	}

	const clearLogo = () => {
		setAffinityLogo(null)
	}

	return { fetchLogo, clearLogo }
}